import { QuizAnswerCreateDTO } from '@/models/Answer';
import {
  QuizAnswersType,
  QuizElementResponse,
} from '@/models/_deprecated/ActivityElement';
import MultipleChoiceAnswer, {
  QuizAnswerEditType,
} from '@/models/MultipleChoiceAnswer';

type LegacyQuizAnswer = {
  id?: number;
  answer: File | string;
  isCorrect: boolean;
  altText?: string;
  answerVerifier: string;
  editType?: QuizAnswerEditType;
};

type TargetQuizAnswer = {
  id?: number;
  answerVerifier?: string;
};

const resolveAnswerId = (
  { id, answerVerifier }: LegacyQuizAnswer,
  targetAnswers: TargetQuizAnswer[],
) => {
  if (!id) return undefined;
  if (!answerVerifier) return id;
  const target = targetAnswers.find(
    item => item.answerVerifier === answerVerifier,
  );
  return target?.id ?? id;
};

const resolveAnswerContent = (
  answer: File | string,
  answerType: QuizAnswersType,
) => {
  if (answerType === QuizAnswersType.TEXT) return { text: answer as string };
  return answer instanceof File ? { mediaFile: answer } : {};
};

export const toQuizAnswersPayload = (
  answers: LegacyQuizAnswer[],
  answerType: QuizAnswersType,
  targetAnswers: TargetQuizAnswer[] = [],
): QuizAnswerCreateDTO[] =>
  answers
    .filter(({ editType }) => editType !== 'remove')
    .map(answer => ({
      id: resolveAnswerId(answer, targetAnswers),
      ...resolveAnswerContent(answer.answer, answerType),
      altText: answer.altText,
      isCorrect: answer.isCorrect,
    }));

export const toMultipleChoiceAnswers = (
  answers: QuizElementResponse['quizAnswers'],
) =>
  answers.map(({ id, answerVerifier, answer, isCorrect, altText }) =>
    Object.assign(new MultipleChoiceAnswer(answer, isCorrect), {
      id,
      answerVerifier,
      altText,
      editType: undefined,
    }),
  );
